import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { Box, Button, IconButton, Tooltip } from "@mui/material";

import { inject } from "../../../../../../lib/itn-ui-kit/services/service-container";
import Svg, { SvgEnum } from "../../../../ui library/components/svgs/standard/svg";
import Note from "../../../clientNotes/components/Accordion/Note";
import AddEditModal from "../../../clientNotes/components/Modals/AddEditModal";
import LoadingIndicator from "../../../Common/LoadingIndicator/LoadingIndicator";
import useSettlementNotesSection from "../../hooks/useSettlementNotesSection";
import { useSettlementStore } from "../../store/settlementStore";
import { SETTLEMENT_STYLES } from "../../style/styles";

function AddNoteButton({ onClick }) {
  return (
    <Button
      className="max-w-50 min-w-40 normal-case"
      color="primary"
      endIcon={<AddCircleOutlineOutlinedIcon />}
      onClick={onClick}
      sx={SETTLEMENT_STYLES.addButton}
      variant="contained"
    >
      Add
    </Button>
  );
}

export default function SettlementNotesSection() {
  const caseDetail = useSettlementStore((state) => state.caseDetail);
  const currentUserService = inject("current-user-service");
  const userId = currentUserService?.user?.pk ?? currentUserService?.user?.id;
  const {
    canAddNote,
    canEditNote,
    closeModal,
    isLoading,
    isModalOpen,
    mode,
    note,
    openAdd,
    openEdit,
    saveNote,
  } = useSettlementNotesSection(caseDetail?.pk);

  return (
    <>
      <section
        className={`flex w-full flex-col overflow-hidden rounded-[12px] p-4 shadow-sm ${
          note || isLoading ? "h-[250px]" : "h-[146px]"
        }`}
        style={SETTLEMENT_STYLES.sectionCard}
      >
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <Svg
              name={SvgEnum.HisClipboardCheck}
              color={SETTLEMENT_STYLES.sectionIconColor}
              sx={SETTLEMENT_STYLES.sectionIcon}
            />
            <h3 className="text-lg font-semibold" style={SETTLEMENT_STYLES.sectionTitle}>
              Notes
            </h3>
          </div>
          {!note && canAddNote ? <AddNoteButton onClick={openAdd} /> : null}
          {note && canEditNote ? (
            <Tooltip title="Edit note">
              <IconButton aria-label="Edit note" onClick={openEdit}>
                <EditOutlinedIcon sx={SETTLEMENT_STYLES.textFieldEditIcon} />
              </IconButton>
            </Tooltip>
          ) : null}
        </div>

        {note || isLoading ? (
          <Box
            className="mt-4 flex min-h-0 flex-1 flex-col overflow-y-auto"
            sx={SETTLEMENT_STYLES.scrollbarSx}
          >
            {isLoading ? (
              <LoadingIndicator defaultPadding="" />
            ) : (
              <div className="px-1 py-2">
                <Note content={note.content} />
              </div>
            )}
          </Box>
        ) : (
          <div
            className="mt-4 flex min-h-[56px] flex-1 items-center justify-center rounded-lg px-6 py-4 text-center text-sm font-semibold"
            style={SETTLEMENT_STYLES.emptyStateCard}
          >
            Nothing to show. Please add a note
          </div>
        )}
      </section>

      <AddEditModal
        data={note}
        handleCloseModal={closeModal}
        handleSubmit={saveNote}
        hideNoteTypeSelector
        hideVisibilityInfo
        mode={mode}
        openModal={isModalOpen}
        useSimpleTitle
        userId={userId}
      />
    </>
  );
}
